import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import * as Sentry from "@sentry/react";

const SentryUserProvider = ({ children }) => {
  const user = useSelector((state) => state.auth.user);
  const previousUser = useRef(null);

  useEffect(() => {
    const currentUserId = user?.userId;

    // Set user in Sentry when authenticated
    if (user && currentUserId !== previousUser.current?.userId) {
      Sentry.setUser({
        id: currentUserId,
        email: user.email,
        username: user.firstName || "Username unavailable",
      });
      previousUser.current = { userId: currentUserId };  // Update the previous user reference
    } else if (!user) {
      // Clear user information in Sentry when logged out
      Sentry.setUser(null);
      previousUser.current = null;  // Clear previous user reference
    }
  }, [user]);

  return children;
};

export default SentryUserProvider;
